// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1Ddg5","right":"styles_right__3_x1c"};